(() => {
  if (window.bannerVideoInitialized) return;
  window.bannerVideoInitialized = true;

  const desktopQuery = window.matchMedia('(min-width: 768px)');

  // A first-screen video gets its file from <source media> during parsing; only a source that
  // never matched (the other breakpoint) is left for JS to fill in.
  const hasSource = video =>
    Boolean(video.getAttribute('src') || video.currentSrc) ||
    (video.querySelector('source') !== null &&
      video.networkState !== HTMLMediaElement.NETWORK_NO_SOURCE);

  const primeVideo = video => {
    if (!video.dataset.src || hasSource(video)) return;
    video.muted = true;
    video.setAttribute('src', video.dataset.src);
    video.load();
  };

  const playVideo = video => {
    primeVideo(video);
    const played = video.play();
    if (played && typeof played.catch === 'function') {
      played.catch(() => {});
    }
  };

  const syncVideos = () => {
    const wantedMedia = desktopQuery.matches ? 'desktop' : 'mobile';

    document.querySelectorAll('[data-banner-video-root]').forEach(root => {
      root.querySelectorAll('[data-banner-video]').forEach(video => {
        if (video.dataset.bannerVideo === wantedMedia) {
          playVideo(video);
        } else {
          video.pause();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncVideos);
  } else {
    syncVideos();
  }

  desktopQuery.addEventListener('change', syncVideos);
  document.addEventListener('shopify:section:load', syncVideos);
})();
